import { render, staticRenderFns } from "./upgradeModal.vue?vue&type=template&id=38a458b6&scoped=true"
import script from "./upgradeModal.vue?vue&type=script&lang=js"
export * from "./upgradeModal.vue?vue&type=script&lang=js"
import style0 from "./upgradeModal.vue?vue&type=style&index=0&id=38a458b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a458b6",
  null
  
)

export default component.exports